import { DomainRule } from '../../types';

export interface DateCantBeInThePastRuleDto {
  date: Date;
}

export const DateCantBeInThePastRuleKey = 'dateCantBeInThePastRule';

export const DateCantBeInThePastRule = ({ date }: DateCantBeInThePastRuleDto): DomainRule => {
  if (!date) {
    return {
      result: 'pass',
      ruleKey: undefined,
    };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (today > date) {
    return {
      result: 'fail',
      ruleKey: DateCantBeInThePastRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
